import { initApp } from "./main";

var loadVideoInterval;

// index.html has a script copied from youTube to load youTube's iframe.api
// when loaded it creates a global variable YT
// youTube's API does not come in module form so checking the state of
// global variable I've created to signal that it has loaded and ready
function tryToLoadVideo() {
  if (document.isYouTubeReady) {
    clearInterval(loadVideoInterval);
    initApp();
  }
}

loadVideoInterval = setInterval(tryToLoadVideo, 200);
